(function () {
  "use strict";

  var candidates = [
    { id: "tacyagi", name: "CHA TACYAGI-70", href: "#mil-tacyagi70", role: "Portable directional UHF for 400–470 MHz line-of-sight and direction-finding work.", tags: ["uhf", "local", "directional", "dismounted", "vehicle", "rapid"] },
    { id: "mpas2", name: "CHA MPAS 2.0", href: "#mil-mpas2", role: "Broad portable HF family with documented vertical and supported-wire configurations.", tags: ["hf", "dismounted", "vehicle", "temporary", "vertical", "wire", "both", "rapid", "deliberate", "none", "one", "two", "multi", "power"] },
    { id: "mpaslite", name: "CHA MPAS Lite", href: "#mil-mpas-lite", role: "Approximately four-pound HF package with vertical and supported-wire paths.", tags: ["hf", "dismounted", "ultralight", "manpack", "vertical", "wire", "both", "rapid", "none", "one", "two", "multi"] },
    { id: "tdl", name: "CHA TDL", href: "#mil-tdl", role: "Portable HF system with loop, vertical, horizontal-dipole, and V-dipole options.", tags: ["hf", "dismounted", "vehicle", "temporary", "manpack", "vertical", "wire", "both", "rapid", "none", "one", "two", "multi", "power"] },
    { id: "lefs", name: "CHA LEFS 8010", href: "#mil-lefs8010", role: "Lightweight supported HF wire with a documented 130-foot 80 m option.", tags: ["hf", "regional", "distance", "mixed", "dismounted", "ultralight", "manpack", "wire", "rapid", "deliberate", "one", "two", "power"] },
    { id: "nvis", name: "CHA NVIS family", href: "#mil-nvis-family", role: "Purpose-oriented, deliberate regional-HF starting geometry.", tags: ["hf", "regional", "temporary", "fixed", "wire", "deliberate", "one", "two"] },
    { id: "td2", name: "CHA TD 2.0 + CHA HPD", href: "#mil-td-hpd", role: "Adaptable HF wire family with longer-wire expansion paths.", tags: ["hf", "regional", "distance", "mixed", "dismounted", "temporary", "wire", "deliberate", "one", "two", "multi", "power"] },
    { id: "emcommportable", name: "CHA EMCOMM III Portable", href: "#mil-emcomm-portable", role: "Compact HF wire for controlled alternate and contingency roles.", tags: ["hf", "regional", "distance", "mixed", "dismounted", "manpack", "wire", "rapid", "one", "two"] },
    { id: "emcommbase", name: "CHA EMCOMM III Base", href: "#mil-emcomm-base", role: "Long HF wire system for deliberate base and continuity installations.", tags: ["hf", "regional", "distance", "mixed", "temporary", "fixed", "transportable", "wire", "site", "one", "two", "power"] },
    { id: "skyloop40", name: "CHA SKYLOOP 40", href: "#mil-skyloop40", role: "Compact four-support HF loop for deliberate regional and BLOS planning.", tags: ["hf", "regional", "distance", "mixed", "temporary", "fixed", "transportable", "site", "four", "power"] },
    { id: "skyloop2", name: "CHA SKYLOOP 2.0", href: "#mil-skyloop2", role: "Large four-support multiband HF loop for headquarters and continuity sites.", tags: ["hf", "regional", "distance", "mixed", "fixed", "transportable", "site", "four", "power"] },
    { id: "portamast", name: "CHA PORTA-MAST", href: "#mil-porta-mast", role: "Mechanical support subsystem for a defined compatible antenna and mount.", tags: ["hf", "vehicle", "temporary", "fixed", "transportable", "one", "site"] }
  ];

  function plannerValue(form, name) {
    var field = form.elements[name];
    if (!field) return "";
    if (field.type === "checkbox") return field.checked ? field.value : "";
    return String(field.value || "").trim();
  }

  function plannerLabel(form, name) {
    var field = form.elements[name];
    if (!field) return "";
    if (field.type === "checkbox") return field.checked ? "Yes" : "No / not selected";
    if (field.tagName === "SELECT" && field.selectedIndex >= 0) {
      return String(field.options[field.selectedIndex].textContent || "").trim();
    }
    return String(field.value || "").trim();
  }

  function initPlanner(root) {
    var form = root.querySelector("[data-military-planner]");
    var results = root.querySelector("[data-military-results]");
    var grid = root.querySelector("[data-military-result-grid]");
    var notes = root.querySelector("[data-military-result-notes]");
    var email = root.querySelector("[data-military-email]");
    if (!form || !results || !grid || !notes || !email) return;

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var values = {
        path: plannerValue(form, "path"), spectrum: plannerValue(form, "spectrum"),
        mobility: plannerValue(form, "mobility"), weight: plannerValue(form, "weight"),
        supports: plannerValue(form, "supports"), geometry: plannerValue(form, "geometry"),
        setup: plannerValue(form, "setup"), radio: plannerValue(form, "radio"),
        jump: plannerValue(form, "jump"), multi: plannerValue(form, "multi"), power: plannerValue(form, "power")
      };
      var desired = [values.path, values.mobility, values.weight, values.supports, values.geometry, values.setup];
      if (values.multi) desired.push("multi");
      if (values.power) desired.push("power");
      var spectrumFamilies = values.spectrum.split("-");
      var wantsVhf = spectrumFamilies.indexOf("vhf") !== -1;
      var wantsUhf = spectrumFamilies.indexOf("uhf") !== -1 || values.geometry === "directional";
      var wantsHf = values.spectrum === "unknown" || spectrumFamilies.indexOf("hf") !== -1;
      var scored = candidates.map(function (candidate, index) {
        var score = 0;
        desired.forEach(function (value) { if (value && value !== "unknown" && candidate.tags.indexOf(value) !== -1) score += 2; });
        if (candidate.id === "tacyagi") score += wantsUhf ? 12 : -20;
        else score += wantsHf ? 3 : -12;
        if (wantsHf && wantsUhf && candidate.id === "tacyagi") score += 5;
        if (values.supports === "none" && ["mpas2", "mpaslite", "tdl"].indexOf(candidate.id) === -1) score -= 8;
        if (values.weight === "ultralight" && candidate.id !== "mpaslite" && candidate.id !== "lefs" && candidate.id !== "tacyagi") score -= 7;
        if (values.mobility === "fixed" && ["skyloop40", "skyloop2", "emcommbase", "nvis"].indexOf(candidate.id) !== -1) score += 5;
        return { candidate: candidate, score: score, index: index };
      }).sort(function (a, b) { return b.score - a.score || a.index - b.index; });

      var selected;
      if (!wantsHf && wantsUhf) selected = scored.filter(function (item) { return item.candidate.id === "tacyagi"; });
      else if (wantsHf && wantsUhf) selected = [scored.find(function (item) { return item.candidate.id === "tacyagi"; })].concat(scored.filter(function (item) { return item.candidate.id !== "tacyagi"; }).slice(0, 2));
      else if (!wantsHf && wantsVhf) selected = [];
      else selected = scored.filter(function (item) { return item.candidate.id !== "tacyagi"; }).slice(0, 3);

      grid.replaceChildren();
      var reasonLabels = {
        local: "local line-of-sight work", regional: "regional HF coverage", distance: "longer-distance HF",
        mixed: "mixed HF paths", dismounted: "dismounted use", vehicle: "vehicle-supported use",
        temporary: "temporary sites", fixed: "fixed sites", ultralight: "the stated weight limit",
        manpack: "manpack use", none: "no external support", one: "one available support",
        two: "two available supports", four: "four available supports", site: "site infrastructure",
        vertical: "vertical geometry", wire: "wire geometry", both: "multiple geometries",
        directional: "directional coverage", rapid: "rapid setup", deliberate: "deliberate setup",
        multi: "multiple antenna geometries", power: "higher-power review"
      };
      if (!selected.filter(Boolean).length) {
        var noMatch = document.createElement("article");
        var noMatchTitle = document.createElement("h4");
        var noMatchCopy = document.createElement("p");
        noMatchTitle.textContent = "No governed product candidate is presented for this spectrum selection";
        noMatchCopy.textContent = "Keep the requirement in the generated support summary. Military Technical Support can confirm whether Chameleon has an appropriate current system or whether the requirement needs a different supplier path.";
        noMatch.append(noMatchTitle, noMatchCopy);
        grid.append(noMatch);
      }
      selected.filter(Boolean).forEach(function (item, index) {
        var article = document.createElement("article");
        var rank = document.createElement("span");
        var title = document.createElement("h4");
        var copy = document.createElement("p");
        var why = document.createElement("small");
        var link = document.createElement("a");
        rank.textContent = String(index + 1).padStart(2, "0");
        title.textContent = item.candidate.name;
        copy.textContent = item.candidate.role;
        var matched = desired.filter(function (value) {
          return value && value !== "unknown" && item.candidate.tags.indexOf(value) !== -1 && reasonLabels[value];
        }).map(function (value) { return reasonLabels[value]; });
        if (item.candidate.id === "tacyagi" && wantsUhf) matched.unshift("the UHF requirement");
        why.textContent = "Why it surfaced: " + (matched.length ? Array.from(new Set(matched)).slice(0, 3).join(", ") : "a broad starting fit for the stated requirement") + ".";
        link.href = item.candidate.href;
        link.textContent = "Review system record →";
        article.append(rank, title, copy, why, link);
        grid.append(article);
      });

      var missing = [];
      if (values.path === "unknown") missing.push("communications range or role");
      if (values.spectrum === "unknown") missing.push("HF, VHF, or UHF");
      if (values.mobility === "unknown") missing.push("deployment type");
      if (values.weight === "unknown") missing.push("weight limit");
      if (values.supports === "unknown") missing.push("available supports");
      if (!values.radio) missing.push("exact radio model and interface chain");
      var noteList = [];
      if (missing.length) noteList.push("Still to confirm with Military Technical Support: " + missing.join(", ") + ".");
      if (values.jump) noteList.push("Airborne-insertion compatibility requires a separate load-plan and approval review; this guide makes no jump or airworthiness certification.");
      if (values.power) noteList.push("Confirm amplifier, tuner or coupler, waveform, duty cycle, feed line, and the lowest power limit in the complete chain.");
      if (wantsUhf) noteList.push("The TACYAGI-70 is the directional UHF family presented here and is documented only for 400–470 MHz; other UHF, omnidirectional, and SATCOM requirements need a separate discussion.");
      if (wantsVhf) noteList.push("The TACYAGI-70 does not cover VHF. This page does not currently present a governed directional VHF antenna family; review that requirement directly with Military Technical Support.");
      noteList.push("Do not email classified information, CUI, exact operational locations, call signs, operational frequencies, or deployment dates.");
      notes.replaceChildren();
      var heading = document.createElement("strong");
      var list = document.createElement("ul");
      heading.textContent = "Discussion notes";
      noteList.forEach(function (note) { var li = document.createElement("li"); li.textContent = note; list.append(li); });
      notes.append(heading, list);

      var labels = {
        path: "Role", spectrum: "Spectrum", mobility: "Deployment", weight: "Weight limit",
        supports: "Supports", geometry: "Antenna options", setup: "Setup objective", radio: "Radio"
      };
      var lines = ["Military Systems & Technical Support,", "", "I used the Military Mission Configuration Guide. Here is the unclassified starting requirement:"];
      Object.keys(labels).forEach(function (key) { lines.push(labels[key] + ": " + (plannerLabel(form, key) || "Not provided")); });
      lines.push("Airborne-insertion load-plan review: " + (values.jump ? "Yes" : "No / not selected"));
      lines.push("Multiple antenna geometries requested: " + (values.multi ? "Yes" : "No / not selected"));
      lines.push("Higher-power review requested: " + (values.power ? "Yes" : "No / not selected"));
      lines.push("", "Starting candidates: " + selected.filter(Boolean).map(function (item) { return item.candidate.name; }).join(", "), "", "Please help me confirm the correct complete configuration and purchasing path.");
      var recipient = email.getAttribute("href").replace(/^mailto:/, "").split("?")[0];
      email.href = "mailto:" + recipient + "?subject=" + encodeURIComponent("Military antenna requirement from Mission Configuration Guide") + "&body=" + encodeURIComponent(lines.join("\n"));
      results.hidden = false;
      results.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
    });

    form.addEventListener("reset", function () {
      window.setTimeout(function () { results.hidden = true; grid.replaceChildren(); notes.replaceChildren(); }, 0);
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    initPlanner(root);

    [".cha-mil__family-grid", ".cha-mil__pattern-showcase"].forEach(function (selector) {
      var group = root.querySelector(selector);
      if (!group) return;
      group.querySelectorAll(":scope > details").forEach(function (item) {
        item.addEventListener("toggle", function () {
          if (!item.open) return;
          group.querySelectorAll(":scope > details[open]").forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });

    function openEvidence(hash, scroll) {
      if (!hash || hash.indexOf("#mil-nec-") !== 0) return false;
      var anchored;
      try { anchored = root.querySelector(hash); }
      catch (error) { return false; }
      if (!anchored || anchored.tagName !== "DETAILS" || !anchored.classList.contains("cha-mil__pattern-card")) return false;
      var group = anchored.parentElement;
      if (group) {
        group.querySelectorAll(":scope > details[open]").forEach(function (other) {
          if (other !== anchored) other.open = false;
        });
      }
      anchored.open = true;
      var summary = anchored.querySelector(":scope > summary");
      window.setTimeout(function () {
        if (scroll) anchored.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
        if (summary) {
          if (!summary.hasAttribute("tabindex")) summary.setAttribute("tabindex", "-1");
          summary.focus({ preventScroll: true });
        }
      }, 60);
      return true;
    }

    root.addEventListener("click", function (event) {
      var link = event.target.closest('a[href^="#mil-nec-"]');
      if (!link || !root.contains(link)) return;
      var hash = link.getAttribute("href");
      if (!openEvidence(hash, true)) return;
      event.preventDefault();
      if (window.location.hash !== hash) history.pushState(history.state, "", hash);
    });

    window.addEventListener("hashchange", function () { openEvidence(window.location.hash, true); });
    if (window.location.hash) openEvidence(window.location.hash, false);
  }

  function boot() {
    document.querySelectorAll("[data-military-capability-center]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
